export const ROUTES_NAMES = {
  home: 'home',
  login: 'login',
  cardOperations: 'cardOperations',
  tickets: 'tickets',
  wallet: 'wallet',
  reporting: 'reporting',
  settings: 'settings',
  settingsDeviceControls: 'settingsDeviceControls',
  settingsLandingPage: 'settingsLandingPage',
  settingsServiceMode: 'settingsServiceMode',
  certificate: 'certificate',
  about: 'about',
  reportingPhysicalCash: 'reportingPhysicalCash',
  reportingBillingReport: 'reportingBillingReport'
} as const
